export const ApiEndpoints = {
  ACCOUNTS: 'accounts',
  ANALYTICS_EVENTS: 'analytics_events',
  ANALYTICS_FEATURE_VISITS: 'feature_visits',
  ANALYTICS_PAGEVIEWS: 'analytics_pageviews',
  ANALYTICS_SESSION: 'analytics_sessions',
  APP_DATA: 'raja/data?type=master',
  BEATS: 'beats',
  BUDGETS: 'budgets',
  CATEGORIES: 'categories',
  CHANGE_PASSWORD: 'user/change_password',
  DATE_RANGE_CATEGORY_TOTALS: 'date_range_category_totals',
  DEVICES: 'devices',
  EMAIL_VERIFICATIONS: 'email_verifications',
  GOALS: 'goals',
  HEALTH_SCORES: 'health_scores',
  HOLDINGS: 'holdings',
  INSTITUTIONS: 'institutions',
  INSIGHTS_NOTIFICATION_PROFILES: 'insight_notification_profiles',
  LOCALIZED_COPY: 'localized_copies',
  LOCALIZED_CONTENT: 'localized_content',
  MEMBERS: 'members',
  MERCHANTS: 'merchants',
  MERCHANT_BUDGETS: 'merchant_budgets',
  MONTHLY_CASH_FLOW_PROFILE: 'monthly_cash_flow_profile',
  MONTHLY_CATEGORY_TOTALS: 'monthly_category_totals',
  OFFERS: 'offers',
  NOTIFICATION_PROFILES: 'notification_profiles',
  NOTIFICATIONS: 'notifications',
  PHONE_VERIFICATIONS: 'sms_verification',
  PULSE_COMMUNICATIONS: 'pulse_communications',
  REPEATING_TRANSACTIONS: 'repeating_transactions',
  RETIREMENT_GOALS: 'retirement_goals',
  RETIREMENT_GOAL_ACCOUNTS: 'retirement_goal_accounts',
  SCHEDULED_PAYMENTS: 'scheduled_payments',
  SPENDING_PLANS: 'spending_plans',
  SUPPORT_TICKETS: 'support_tickets',
  TAGGINGS: 'taggings',
  TAGS: 'tags',
  TRANSACTION_RULES: 'transaction_rules',
  TRANSACTIONS: 'transactions',
  USER: 'user',
  USER_COMMUNICATION_PROFILE: 'user_communication_profile',
  USER_FEATURES: 'user_features',
  USER_PROFILES: 'user_profiles',
  WIDGET_URLS: 'widget_urls',
}
